import { Heading, Stack } from "@origin-digital/ods-core";
import React from "react";
import FormFieldLayout from "../FormComponents/FormFieldLayout";
import GeneralTextField from "../FormComponents/GeneralTextField";
import { Field } from "formik";
import ContactField from "../FormComponents/ContactField";

const ElectricianSection: React.FC<{ noCompany: boolean }> = ({
  noCompany,
}) => {
  return (
    <Stack
      space={{
        xs: "xlarge",
        md: "xxlarge",
      }}
      id="electricianSection"
    >
      {noCompany ? (
        <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
          <FormFieldLayout multipleFields>
            <Heading variant="h4">Licensed electrician</Heading>
            <Field
              name="electricianFields.firstName"
              component={GeneralTextField}
              label="First Name"
              required
            />
          </FormFieldLayout>

          <FormFieldLayout>
            <Field
              name="electricianFields.lastName"
              component={GeneralTextField}
              label="Last Name"
              required
            />
          </FormFieldLayout>
          <FormFieldLayout>
            <Field
              name="electricianFields.companyName"
              component={GeneralTextField}
              label="Company Name (Optional)"
            />
          </FormFieldLayout>
          <FormFieldLayout>
            <Field
              name="electricianFields.phoneNumber"
              component={GeneralTextField}
              label="Phone Number"
              required
            />
          </FormFieldLayout>
          <FormFieldLayout>
            <Field
              name="electricianFields.emailAddress"
              component={GeneralTextField}
              label="Email Address"
              required
            />
          </FormFieldLayout>
          <FormFieldLayout>
            <Field
              name="electricianFields.licenceNumber"
              component={GeneralTextField}
              label="Licence Number"
              required
            />
          </FormFieldLayout>
        </Stack>
      ) : (
        <FormFieldLayout multipleFields>
          <Heading variant="h4">Licensed electrician</Heading>
          <ContactField
            contactType="ELECTRICIAN"
            name="licensedElectrician"
            label="Licensed electrician"
          />
        </FormFieldLayout>
      )}
    </Stack>
  );
};

export default ElectricianSection;
